export enum Role {
	Api = "ROLE_API",
	SuperAdmin = "ROLE_SUPER_ADMIN"
}


// WEBPACK FOOTER //
// ./src/constant/role.ts